import React from "react";
import Button from "@src/components/Button";
import { Box } from "@src/components/Boxes";
import styled from "@emotion/styled";

const MenuContainer = styled.div`
  position: absolute;
  left: 100%;
  top: 100%;
  transform: translate(-100%, 0%);
  padding: 7px 0 0;
  z-index: 110;
  text-align: right;
`;

const MenuInnerContainer = styled.div`
  max-width: 250px;
  display: inline-block;
  position: relative;
`;

const Menu = styled.div`
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 5px 0;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: left;
  color: rgb(54, 54, 54);
  font-size: 16px;
  padding: 0;
  cursor: default;
`;

const MenuUl = styled.ul`
  overflow: hidden auto;
  text-overflow: ellipsis;
  line-height: normal;
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 6px;
  max-height: 220px;
  min-width: 250px;
`;

const MenuItem = styled.li`
  color: black;
  padding: 0 30px 0 10px;
  border-bottom: 1px solid rgb(218, 218, 218);
  outline: none;
  font-size: 16px;
  height: 40px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;

  :hover {
    background-color: rgb(245, 245, 245);
  }
`;

const ShareStatus = styled.div`
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 5px 0;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: center;
  color: rgb(54, 54, 54);
  font-size: 16px;
  padding: 20px;

  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

class ShareToClassStory extends React.Component<any, any> {
  state = {
    sharingTo: null,
    menuOpen: false,
  };

  render() {
    if (!this.props.classes || !this.props.body) {
      return null;
    }

    return (
      <div>
        {this._confirmationPopover(this.state.sharingTo, this.props.shareStatus) || (
          <Box>
            <Button onClick={() => this.setState({ menuOpen: !this.state.menuOpen })}>Share on Class Story</Button>
            {this.state.menuOpen && (
              <MenuContainer>
                <MenuInnerContainer>
                  <Menu>
                    <MenuUl>{this._menuItems(this.props as any)}</MenuUl>
                  </Menu>
                </MenuInnerContainer>
              </MenuContainer>
            )}
          </Box>
        )}
      </div>
    );
  }

  _confirmationPopover(sharingTo, shareStatusMap) {
    if (!sharingTo || !shareStatusMap) {
      return null;
    }

    const shareStatus = shareStatusMap[sharingTo.key];
    let body = null;

    if (shareStatus === "pending") {
      body = (
        <>
          Sharing to {sharingTo.name}
          ...
        </>
      );
    }

    if (shareStatus === "done") {
      body = (
        <>
          <div>Shared to {sharingTo.name}!</div>
          <Button onClick={() => this.setState({ sharingTo: null })}>OK</Button>
        </>
      );
    }

    if (shareStatus === "error") {
      body = (
        <>
          <div>Error sharing to {sharingTo.name}!</div>
          <Button onClick={() => this.setState({ sharingTo: null })}>OK</Button>
        </>
      );
    }

    return <ShareStatus>{body}</ShareStatus>;
  }

  _menuItems({ classes, onShare }) {
    return classes.map((aclass, i) => {
      return (
        <MenuItem
          key={i}
          onClick={(e) => {
            e.preventDefault();
            this.setState({ menuOpen: !this.state.menuOpen });
            this._onClickClass(onShare, aclass);
          }}
        >
          {aclass.name}
        </MenuItem>
      );
    });
  }

  _onClickClass(onShare, aclass) {
    this.setState({
      sharingTo: {
        name: aclass.name,
        key: aclass._id,
      },
    });

    if (typeof onShare === "function") {
      onShare(aclass._id, this.props.body, this.props.image);
    }
  }
}

export default ShareToClassStory;
